import { defineStore } from "pinia";
import { mande } from "mande";

export interface User {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    street: string;
    number: string;
    addition: string;
    postal_code: string;
    city: string;
    birth_date: string;
    membership_end_date: string;
}

const api = mande("/api");
const json = mande("/json");

export const useAuthStore = defineStore("auth", {
    state: () => {
        return {
            user: undefined,
        } as { user?: User };
    },

    actions: {
        async readUser(renewal_key: string): Promise<User> {
            function delay(time: number): Promise<any> {
                return new Promise((resolve) => setTimeout(resolve, time));
            }

            await delay(1000);

            const user = {
                first_name: "Geert",
                last_name: "Plessers",
                email: "geert@salamander.be",
                phone: "0498531918",
                street: "Torbeekstraat",
                number: "10",
                addition: "",
                postal_code: "3910",
                city: "Pelt",
                birth_date: "27/07/1993",
                membership_end_date: "27/07/2023",
            };

            this.user = user;

            return this.user;
        },
    },
});
